import { Button, H4, Popover, Position } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useClusterProjectRows } from "in_queue/hooks/useClusterProjectRows";
import { UploadSensitivitiesMenu } from "../ScenarioDialog/UploadSensitivitiesMenu";
import { TableActionRibbon } from "../tables/ribbon/TableActionRibbon";
import {
    ProjectPickerTable,
    ProjectPickerTableProps
} from "./ProjectPickerTable";
import { ScenarioBuilderLabel } from "./scenarioBuilderParams";
import css from "./SensitivitiesStep.module.scss";

/** The builder's sensitivities step: a heading with CSV import / export above the project picker. */
export const SensitivitiesStep: React.FC<ProjectPickerTableProps> = (props) => {
    const {
        projectSizeAssumptions,
        setProjectSizeAssumptions,
        includedSpeculativeProjectIds,
        setIncludedSpeculativeProjectIds
    } = props;
    const { rows: clusterRowsL } = useClusterProjectRows();
    const clusterRows = clusterRowsL === "loading" ? [] : clusterRowsL;

    return (
        <div className={css["SensitivitiesStep"]}>
            <TableActionRibbon
                leftActions={[
                    <H4
                        key="heading"
                        className={css["SensitivitiesStep-heading"]}
                    >
                        {ScenarioBuilderLabel.Sensitivities}
                    </H4>
                ]}
                rightActions={[
                    <Popover
                        key="csv"
                        position={Position.BOTTOM_RIGHT}
                        content={
                            <UploadSensitivitiesMenu
                                baseScenarioRows={clusterRows}
                                projectSizeAssumptions={projectSizeAssumptions}
                                setProjectSizeAssumptions={
                                    setProjectSizeAssumptions
                                }
                                includedSpeculativeProjectIds={
                                    includedSpeculativeProjectIds
                                }
                                setIncludedSpeculativeProjectIds={
                                    setIncludedSpeculativeProjectIds
                                }
                            />
                        }
                    >
                        <Button
                            text="Import / export"
                            icon={IconNames.IMPORT}
                            rightIcon={IconNames.CARET_DOWN}
                            outlined
                        />
                    </Popover>
                ]}
            />
            <ProjectPickerTable {...props} />
        </div>
    );
};
